/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from "vue";
import { store } from "../store";

export const actions = {
  getNotificationsConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // Setup connection with backend
      store.dispatch("userModule/loadClientsBackConnection", { root: true });

      Vue.http
        .get(`api/notifications/config`)
        .then(response => {
          commit("setNotificationsConfig", response.body.data);
          resolve(response.body.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveNotificationsConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // Setup connection with backend
      store.dispatch("userModule/loadClientsBackConnection", { root: true });

      Vue.http
        .post(`api/notifications/config`, { notificationData: payload })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getNotificationsConfigByTrip({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // Setup connection with backend
      store.dispatch("userModule/loadClientsBackConnection", { root: true });
      
      Vue.http
        .get(`api/notifications/config/trip`, {
          params: { trip_id: payload.tripId }
        })
        .then(response => {
          commit("setNotificationsConfigByTrip", {
            data: payload,
            response: response.body.data
          });
          resolve(response.body.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveNotificationsConfigByTrip({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // Setup connection with backend
      store.dispatch("userModule/loadClientsBackConnection", { root: true });

      Vue.http
        .post(`api/notifications/config/trip`, {
          trip_id: payload.data.tripId,
          phone_number: payload.data.lada_number + payload.data.phone_number,
          enabled: payload.data.enabled
        })
        .then(response => {
          resolve(response.body.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addEmptyPhoneNumber({ commit }) {
    commit("setEmptyPhoneNumber");
  }
};
